((e) => {
  "function" == typeof define && define.amd
    ? define(["jquery"], e)
    : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
})(function (B) {
  (B.fn.marquee = function (A) {
    return this.each(function () {
      var a,
        r,
        n,
        i,
        s,
        o = B.extend({}, B.fn.marquee.defaults, A),
        u = B(this),
        d = 3,
        e = "animation-play-state",
        p = !1,
        l = function (e, t, a) {
          for (
            var r = ["webkit", "moz", "MS", "o", ""], n = 0;
            n < r.length;
            n++
          )
            r[n] || (t = t.toLowerCase()), e.addEventListener(r[n] + t, a, !1);
        },
        f = function (e) {
          var t,
            a = [];
          for (t in e) e.hasOwnProperty(t) && a.push(t + ":" + e[t]);
          return a.push(), "{" + a.join(",") + "}";
        },
        c = function () {
          u.timer = setTimeout(k, o.delayBeforeStart);
        },
        t = {
          pause: function () {
            p && o.allowCss3Support
              ? a.css(e, "paused")
              : B.fn.pause && a.pause(),
              u.data("runningStatus", "paused"),
              u.trigger("paused");
          },
          resume: function () {
            p && o.allowCss3Support
              ? a.css(e, "running")
              : B.fn.resume && a.resume(),
              u.data("runningStatus", "resumed"),
              u.trigger("resumed");
          },
          toggle: function () {
            t["resumed" === u.data("runningStatus") ? "pause" : "resume"]();
          },
          destroy: function () {
            clearTimeout(u.timer),
              u.find("*").addBack().off(),
              u.html(u.find(".js-marquee:first").html());
          },
        };
      if ("string" == typeof A)
        B.isFunction(t[A]) &&
          ((a = a || u.find(".js-marquee-wrapper")),
          !0 === u.data("css3AnimationIsSupported") && (p = !0),
          t[A]());
      else {
        B.each(o, function (e) {
          if (void 0 !== (m = u.attr("data-" + e))) {
            switch (m) {
              case "true":
                m = !0;
                break;
              case "false":
                m = !1;
            }
            o[e] = m;
          }
        }),
          o.speed && (o.duration = (parseInt(u.width(), 10) / o.speed) * 1e3),
          (i = "up" === o.direction || "down" === o.direction),
          (o.gap = o.duplicated ? parseInt(o.gap) : 0),
          u.wrapInner('<div class="js-marquee"></div>');
        var m,
          g,
          h,
          y = u
            .find(".js-marquee")
            .css({ "margin-right": o.gap, float: "left" });
        if (
          (o.duplicated && y.clone(!0).appendTo(u),
          u.wrapInner(
            '<div style="width:100000px" class="js-marquee-wrapper"></div>',
          ),
          (a = u.find(".js-marquee-wrapper")),
          i
            ? ((g = u.height()),
              a.removeAttr("style"),
              u.height(g),
              u
                .find(".js-marquee")
                .css({
                  float: "none",
                  "margin-bottom": o.gap,
                  "margin-right": 0,
                }),
              o.duplicated &&
                u.find(".js-marquee:last").css({ "margin-bottom": 0 }),
              (h = u.find(".js-marquee:first").height() + o.gap),
              o.startVisible && !o.duplicated
                ? ((o._completeDuration =
                    ((parseInt(h, 10) + parseInt(g, 10)) / parseInt(g, 10)) *
                    o.duration),
                  (o.duration =
                    (parseInt(h, 10) / parseInt(g, 10)) * o.duration))
                : (o.duration =
                    ((parseInt(h, 10) + parseInt(g, 10)) / parseInt(g, 10)) *
                    o.duration))
            : ((s = u.find(".js-marquee:first").width() + o.gap),
              (r = u.width()),
              o.startVisible && !o.duplicated
                ? ((o._completeDuration =
                    ((parseInt(s, 10) + parseInt(r, 10)) / parseInt(r, 10)) *
                    o.duration),
                  (o.duration =
                    (parseInt(s, 10) / parseInt(r, 10)) * o.duration))
                : (o.duration =
                    ((parseInt(s, 10) + parseInt(r, 10)) / parseInt(r, 10)) *
                    o.duration)),
          o.duplicated && (o.duration = o.duration / 2),
          o.allowCss3Support)
        ) {
          var x = document.body || document.createElement("div"),
            I = "marqueeAnimation-" + Math.floor(1e7 * Math.random()),
            v = "Webkit Moz O ms Khtml".split(" "),
            w = "animation",
            S = "",
            b = "";
          if (
            (void 0 !== x.style.animation &&
              ((b = "@keyframes " + I + " "), (p = !0)),
            !1 === p)
          )
            for (var q = 0; q < v.length; q++)
              if (void 0 !== x.style[v[q] + "AnimationName"]) {
                var j = "-" + v[q].toLowerCase() + "-",
                  w = j + w,
                  e = j + e,
                  b = "@" + j + "keyframes " + I + " ",
                  p = !0;
                break;
              }
          p &&
            ((S =
              I +
              " " +
              o.duration / 1e3 +
              "s " +
              o.delayBeforeStart / 1e3 +
              "s infinite " +
              o.css3easing),
            u.data("css3AnimationIsSupported", !0));
        }
        var C = function () {
            a.css(
              "transform",
              "translateY(" +
                ("up" === o.direction ? g + "px" : "-" + h + "px") +
                ")",
            );
          },
          V = function () {
            a.css(
              "transform",
              "translateX(" +
                ("left" === o.direction ? r + "px" : "-" + s + "px") +
                ")",
            );
          },
          k =
            (o.duplicated
              ? (i
                  ? o.startVisible
                    ? a.css("transform", "translateY(0)")
                    : a.css(
                        "transform",
                        "translateY(" +
                          ("up" === o.direction
                            ? g + "px"
                            : "-" + (2 * h - o.gap) + "px") +
                          ")",
                      )
                  : o.startVisible
                    ? a.css("transform", "translateX(0)")
                    : a.css(
                        "transform",
                        "translateX(" +
                          ("left" === o.direction
                            ? r + "px"
                            : "-" + (2 * s - o.gap) + "px") +
                          ")",
                      ),
                o.startVisible || (d = 1))
              : o.startVisible
                ? (d = 2)
                : (i ? C : V)(),
            function () {
              var e, t;
              o.duplicated &&
                (1 === d
                  ? ((o._originalDuration = o.duration),
                    (o.duration = i
                      ? "up" === o.direction
                        ? o.duration + g / (h / o.duration)
                        : 2 * o.duration
                      : "left" === o.direction
                        ? o.duration + r / (s / o.duration)
                        : 2 * o.duration),
                    (S =
                      S &&
                      I +
                        " " +
                        o.duration / 1e3 +
                        "s " +
                        o.delayBeforeStart / 1e3 +
                        "s " +
                        o.css3easing),
                    d++)
                  : 2 === d &&
                    ((o.duration = o._originalDuration),
                    S &&
                      ((I += "0"),
                      (b = B.trim(b) + "0 "),
                      (S =
                        I +
                        " " +
                        o.duration / 1e3 +
                        "s 0s infinite " +
                        o.css3easing)),
                    d++)),
                i
                  ? o.duplicated
                    ? (2 < d &&
                        a.css(
                          "transform",
                          "translateY(" +
                            ("up" === o.direction ? 0 : "-" + h + "px") +
                            ")",
                        ),
                      (n = {
                        transform:
                          "translateY(" +
                          ("up" === o.direction ? "-" + h + "px" : 0) +
                          ")",
                      }))
                    : o.startVisible
                      ? 2 === d
                        ? ((S =
                            S &&
                            I +
                              " " +
                              o.duration / 1e3 +
                              "s " +
                              o.delayBeforeStart / 1e3 +
                              "s " +
                              o.css3easing),
                          (n = {
                            transform:
                              "translateY(" +
                              ("up" === o.direction
                                ? "-" + h + "px"
                                : g + "px") +
                              ")",
                          }),
                          d++)
                        : 3 === d &&
                          ((o.duration = o._completeDuration),
                          S &&
                            ((I += "0"),
                            (b = B.trim(b) + "0 "),
                            (S =
                              I +
                              " " +
                              o.duration / 1e3 +
                              "s 0s infinite " +
                              o.css3easing)),
                          C())
                      : (C(),
                        (n = {
                          transform:
                            "translateY(" +
                            ("up" === o.direction
                              ? "-" + a.height() + "px"
                              : g + "px") +
                            ")",
                        }))
                  : o.duplicated
                    ? (2 < d &&
                        a.css(
                          "transform",
                          "translateX(" +
                            ("left" === o.direction ? 0 : "-" + s + "px") +
                            ")",
                        ),
                      (n = {
                        transform:
                          "translateX(" +
                          ("left" === o.direction ? "-" + s + "px" : 0) +
                          ")",
                      }))
                    : o.startVisible
                      ? 2 === d
                        ? ((S =
                            S &&
                            I +
                              " " +
                              o.duration / 1e3 +
                              "s " +
                              o.delayBeforeStart / 1e3 +
                              "s " +
                              o.css3easing),
                          (n = {
                            transform:
                              "translateX(" +
                              ("left" === o.direction
                                ? "-" + s + "px"
                                : r + "px") +
                              ")",
                          }),
                          d++)
                        : 3 === d &&
                          ((o.duration = o._completeDuration),
                          S &&
                            ((I += "0"),
                            (b = B.trim(b) + "0 "),
                            (S =
                              I +
                              " " +
                              o.duration / 1e3 +
                              "s 0s infinite " +
                              o.css3easing)),
                          V())
                      : (V(),
                        (n = {
                          transform:
                            "translateX(" +
                            ("left" === o.direction
                              ? "-" + s + "px"
                              : r + "px") +
                            ")",
                        })),
                u.trigger("beforeStarting"),
                p
                  ? (a.css(w, S),
                    (e = b + " { 100%  " + f(n) + "}"),
                    0 !== (t = a.find("style")).length
                      ? t.filter(":last").html(e)
                      : B("head").append("<style>" + e + "</style>"),
                    l(a[0], "AnimationIteration", function () {
                      u.trigger("finished");
                    }),
                    l(a[0], "AnimationEnd", function () {
                      k(), u.trigger("finished");
                    }))
                  : a.animate(n, o.duration, o.easing, function () {
                      u.trigger("finished"), (o.pauseOnCycle ? c : k)();
                    }),
                u.data("runningStatus", "resumed");
            });
        u.on("pause", t.pause),
          u.on("resume", t.resume),
          o.pauseOnHover &&
            (u.on("mouseenter", t.pause), u.on("mouseleave", t.resume)),
          (p && o.allowCss3Support ? k : c)();
      }
    });
  }),
    (B.fn.marquee.defaults = {
      allowCss3Support: !0,
      css3easing: "linear",
      easing: "linear",
      delayBeforeStart: 1e3,
      direction: "left",
      duplicated: !1,
      duration: 5e3,
      speed: 0,
      gap: 20,
      pauseOnCycle: !1,
      pauseOnHover: !1,
      startVisible: !1,
    });
});
